//@ts-expect-error untyped import
import SnowflakeFilterWrapper from '../SnowflakeFilterWrapper';
import InvalidStagedPropertyFilterLabel from './InvalidStagedPropertyFilterLabel';
//@ts-expect-error untyped import
import SnowflakeFilterTile from '../SnowflakeFilterTile';
import { Small } from 'foundations-components/transitional/components/Small';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const InvalidStagedPropertyFilterTile = ({
  filterRef,
  onRemove
}) => {
  return /*#__PURE__*/_jsx(SnowflakeFilterTile, {
    children: /*#__PURE__*/_jsxs(SnowflakeFilterWrapper, {
      highlighted: false,
      onRemove: onRemove,
      children: [/*#__PURE__*/_jsx(InvalidStagedPropertyFilterLabel, {
        propertyFilterRef: filterRef
      }), /*#__PURE__*/_jsx(Small, {
        use: "help",
        children: I18n.text('reporting-snowflake.filter-editor.relative-time-property')
      })]
    })
  });
};
export default InvalidStagedPropertyFilterTile;